import { createSelector } from "reselect";
import { getActiveOrganization } from "selectors/organizations";
import ContactSubTypes from "const/ContactSubTypes";

export const checkContactsFetching = ({ contacts: { fetchingData } }) => fetchingData;

export const getVendorsTags = ({ contacts: { vendorsTags } }) => vendorsTags;

export const getVendorsCategories = ({ contacts: { vendorsCategories } }) => vendorsCategories;

export const getVendorsClasses = ({ contacts: { vendorsClasses } }) => vendorsClasses;

export const getVendorsLocations = ({ contacts: { vendorsLocations } }) => vendorsLocations;

export const getVendorsProjects = ({ contacts: { vendorsProjects } }) => vendorsProjects;

export const getVendorsTaxRates = ({ contacts: { vendorsTaxRates } }) => vendorsTaxRates;

export const getContactsData = ({ contacts: { data } }) => data;

export const getCustomersData = createSelector(
  getContactsData,
  (contacts) => contacts.filter(({ subType }) => subType === ContactSubTypes.CUSTOMER)
);

export const getVendorsData = createSelector(
  getContactsData,
  (contacts) => contacts.filter(({ subType }) => subType === ContactSubTypes.VENDOR)
);

export const getContactsSortedData = createSelector(
  getContactsData,
  (contacts) => {
    return [...contacts]
      .sort(({ name: nameA, subType: subTypeA = "" }, { name: nameB, subType: subTypeB = "" }) => {
        return subTypeA.localeCompare(subTypeB) || nameA.localeCompare(nameB);
      });
  }
);

export const getContactsSubTypeVendorsSortedData = createSelector(
  getContactsSortedData,
  (contacts) => contacts.filter(({ subType }) => !subType || subType === ContactSubTypes.VENDOR)
);

export const getContactsSubTypeCustomerSortedData = createSelector(
  getContactsSortedData,
  (contacts) => contacts.filter(({ subType }) => !subType || subType === ContactSubTypes.CUSTOMER)
);

export const getContactsUniqueCountries = createSelector(
  getContactsData,
  getActiveOrganization,
  (contacts, activeOrganization) => [
    ...new Set([...contacts.map(({ countryCode }) => countryCode), activeOrganization.countryCode])
  ]
);
